const Page404 = () => {
    return (
        <>
            <div className={'container mx-auto text-center pt-64'}>
                <span className={'text-9xl font-sans font-extrabold text-red-600'}>404</span>
                <span className={'font-star-wars text-4xl'}>This planet not exists!</span>
            </div>
        </>
    );
};

export default Page404;
